import type { IntlShape } from 'react-intl';
import { UserConnectionActionType } from '@alltrails/types/belay';

const getUserActionTitle = (intl: IntlShape, actionType?: UserConnectionActionType) => {
  switch (actionType) {
    case UserConnectionActionType.Follow:
    case UserConnectionActionType.FollowBack: // Uses "Follow" for size constraints
      return intl.formatMessage({ defaultMessage: 'Follow' });
    case UserConnectionActionType.Accept:
      return intl.formatMessage({ defaultMessage: 'Accept' });
    case UserConnectionActionType.Block:
      return intl.formatMessage({ defaultMessage: 'Block' });
    case UserConnectionActionType.Unfollow:
      return intl.formatMessage({ defaultMessage: 'Following' });
    case UserConnectionActionType.RetractRequest:
      return intl.formatMessage({ defaultMessage: 'Requested' });
    case UserConnectionActionType.Unblock:
      return intl.formatMessage({ defaultMessage: 'Unblock' });
    case UserConnectionActionType.RemoveFollower:
      return intl.formatMessage({ defaultMessage: 'Remove follower' });
    case UserConnectionActionType.Deny:
      return intl.formatMessage({ defaultMessage: 'Deny' });
    case UserConnectionActionType.Dismiss:
      return intl.formatMessage({ defaultMessage: 'Dismiss' });
    default:
      return '';
  }
};

export default getUserActionTitle;
